// The Idempotency-Key for one invoice draft. A form makes one when it opens,
// sends it with every Save of that draft, and makes a new one only when the
// draft has been saved. The server runs the first Save with a key and answers
// any repeat with that first answer (middlewares/idempotency.js), so Save
// pressed again after a timeout returns the invoice already saved instead of
// filing a second one with the same number.
export const newDraftKey = () =>
  window.crypto?.randomUUID?.() ||
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random()
    .toString(36)
    .slice(2)}`;
